import { useState, useEffect } from 'react';
import { ReactComponent as MyIcon } from "../image/whatsApp.svg";
import { api } from '../api/client';

function Public() {
  const [content, setContent] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [currentFormationImage, setCurrentFormationImage] = useState(0);

  useEffect(() => {
    api.getContent().then(setContent).catch((err) => setLoadError(err.message || 'Erreur inconnue'));
  }, []);

  const heroImages = content?.heroImages || [];
  const formationImages = content?.formationImages || [];
  const features = content?.features || [];
  const products = content?.products || [];
  const partners = content?.partners || [];
  const testimonials = content?.testimonials || [];
  const sponsorshipBenefits = content?.sponsorshipBenefits || [];
  const settings = content?.settings || {};
  const sponsorshipFeatures = Array.isArray(settings['sponsorship.plan_features'])
    ? settings['sponsorship.plan_features']
    : [];

  useEffect(() => {
    if (heroImages.length === 0) return undefined;
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  useEffect(() => {
    if (formationImages.length === 0) return undefined;
    const timerFormation = setInterval(() => {
      setCurrentFormationImage((prev) => (prev + 1) % formationImages.length);
    }, 5000);
    return () => clearInterval(timerFormation);
  }, [formationImages.length]);

  if (loadError) {
    return (
      <div className="App" style={{ padding: 40, textAlign: 'center' }}>
        <p>Le site n'a pas pu charger son contenu ({loadError}).</p>
        <p>Vérifiez que le serveur API tourne bien, puis rechargez la page.</p>
      </div>
    );
  }

  if (!content) {
    return <div className="App" style={{ padding: 40, textAlign: 'center' }}><p>Chargement…</p></div>;
  }

  return (
    <div className="App">
        <a target="_blank" rel="noreferrer" href={settings['footer.whatsapp_link']}>
        <div className="floating-icon">
            <MyIcon className="w-7 h-7 text-white"></MyIcon>
        </div>
     </a>

      <nav className="navbar">
        <div className="container">
        <img className="logo" alt="SENLEM" src={settings['branding.logo_url']}></img>
        </div>
      </nav>

      <section id="hero" className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>{settings['hero.title']}</h1>
            <p>{settings['hero.paragraph']}</p>
          </div>
          <div className="hero-image-container">
            {heroImages.map((image, index) => (
              <div
                key={image.id}
                className={`hero-image ${index === currentImage ? 'active' : ''}`}
              >
                {image.media_type === 'video' ? (
                  <video
                    src={image.url}
                    aria-label={image.alt}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload={index === 0 ? 'auto' : 'metadata'}
                  />
                ) : (
                  <img
                    src={image.url}
                    alt={image.alt}
                    loading={index === 0 ? 'eager' : 'lazy'}
                  />
                )}
              </div>
            ))}
            <div className="hero-image-dots">
              {heroImages.map((image, index) => (
                <button
                  key={image.id}
                  className={`image-dot ${index === currentImage ? 'active' : ''}`}
                  onClick={() => setCurrentImage(index)}
                  aria-label={`Image ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>


      <section id="features" className="features">
        <div className="container">
          <h2>{settings['section.features_title']}</h2>
          <div className="features-grid">
            {features.map((feature) => (
              <div key={feature.id} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="features" className="features">
        <div className="container">
          <h2>{settings['section.formation_title']}</h2>
            <div className="text-align-justify">
            <p>
                {settings['formation.intro']}
            </p>
        </div>
          <div className="features-grid">
            <div className="hero-image-container hero-foramtion-image-container">
            {formationImages.map((image, index) => (
              <div
                key={image.id}
                className={`hero-image ${index === currentFormationImage ? 'active' : ''}`}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
            <div className="hero-image-dots">
              {formationImages.map((image, index) => (
                <button
                  key={image.id}
                  className={`image-dot ${index === currentFormationImage ? 'active' : ''}`}
                  onClick={() => setCurrentFormationImage(index)}
                  aria-label={`Image ${index + 1}`}
                />
              ))}
            </div>
          </div>
          </div>
        </div>
      </section>

      <section id="produits" className="products">
        <div className="container">
          <h2>{settings['section.products_title']}</h2>
                <div className="products-grid">
                    {products.map((product) => (
                        <div key={product.id} className="product-card">
                            <img src={product.picture_url} alt="Miel" />
                            <h3>{product.title}</h3>
                            <p>{product.price}</p>
                        </div>
                    ))}
            </div>
        </div>
      </section>

      <section className="partners">
        <div className="container">
          <h2>{settings['section.partners_title']}</h2>
          <div className="logo-carousel">
            <div className="logo-track">
              {[...partners, ...partners].map((partner, index) => (
                <div key={`${partner.id}-${index}`} className="partner-logo">
                  <a href={partner.link} target="_blank" rel="noopener noreferrer">
                    <img src={partner.logo_url} alt={`Partenaire ${index + 1}`} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
      <div className="container">
          <h2>{settings['section.testimonials_title']}</h2>
          <div className="testimonials-carousel">
            <div className="testimonials-track">
              {[...testimonials, ...testimonials].map((testimonial, index) => (
                <div key={`${testimonial.id}-${index}`} className="testimonial-card">
                  <div className="testimonial-image">
                    <img src={testimonial.image_url} alt={testimonial.name} />
                  </div>
                  <div className="testimonial-content">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-text">"{testimonial.text}"</p>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          </div>
        </section>

      <section id="sponsorship" className="sponsorship">
        <div className="sponsorship-background"></div>
        <div className="container">
          <div className="sponsorship-content">
            <h2>{settings['sponsorship.section_title']}</h2>
            <p className="section-subtitle">
              {settings['sponsorship.section_subtitle']}
            </p>

            <div className="sponsorship-grid">
              {sponsorshipBenefits.map((benefit) => (
                <div key={benefit.id} className="benefit-card">
                  <div className="benefit-icon">{benefit.icon}</div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>

            <div className="sponsorship-plans">
              <div className="plan-card featured">
                <div className="plan-header">
                  <h3>{settings['sponsorship.plan_name']}</h3>
                  <div className="plan-price">
                    <span className="amount">{settings['sponsorship.plan_price_amount']}</span>
                    <span className="currency">{settings['sponsorship.plan_price_currency']}</span>
                  </div>
                </div>
                <ul className="plan-features">
                  {sponsorshipFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <button className="primary-button">Parrainer maintenant</button>
              </div>
            </div>

            <div className="sponsorship-cta">
              <div className="cta-content">
                <h3>{settings['sponsorship.cta_title']}</h3>
                <p>{settings['sponsorship.cta_text']}</p>
                <a href={`mailto:${settings['sponsorship.cta_email']}`}><button className="secondary-button">Contactez-nous</button></a>

              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>{settings['footer.company_name']}</p>
              <p>{settings['footer.owner_name']}</p>
              <p>{settings['footer.address']}</p>
              <p>{settings['footer.phone']}</p>
              <p>{settings['footer.email']}</p>
              <a href={settings['footer.whatsapp_link']}>Whatsapp</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Public;
